import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class NoLineItemSelectedException extends QuoteException {

}